"use client";

import { InstrumentSummary } from "#/components/InstrumentSummary/InstrumentSummary";
import { usePerpInstrumentName } from "#/hooks/usePerpInstrumentName";
import { usePerpIsBuy } from "#/store/perps/tradePanel/perpIsBuy";
import { usePerpLimitPrice } from "#/store/perps/tradePanel/perpLimitPrice";
import { usePerpSize } from "#/store/perps/tradePanel/perpSize";
import { usePerpTradeType } from "#/store/perps/tradePanel/perpTradeType";

export const TradeConfirmationPerpInstrument: React.FC = () => {
  const { perpSize } = usePerpSize();
  const { perpIsBuy } = usePerpIsBuy();
  const { isMarket } = usePerpTradeType();
  const { perpLimitPriceNum } = usePerpLimitPrice();
  const { perpInstrumentName } = usePerpInstrumentName();

  return (
    <InstrumentSummary
      size={perpSize}
      isBuy={perpIsBuy}
      isMarketOrder={isMarket}
      limitPrice={perpLimitPriceNum}
      instrumentName={perpInstrumentName}
    />
  );
};
